/**
 * Created by hyr on 18/11/4.
 * 调用分享面板在share.js中
 * 更新share文案用法：(采用双向绑定方式（getter/setter），动态修改此数据后，分享逻辑中的分享数据会直接修改)
 * import shareData from './config.share';
 *
 * shareData.list = [...];//如需修改端内分享排序
 * shareData.hideMore = true/false;//是否隐藏更多和复制链接
 * ...
 *
 */
import { webviewInfo } from '@ali/amap-lib';

const host = webviewInfo.isPublic() ? 'https://cache.amap.com/' : 'https://testing.amap.com/';
const staticUrl = `${host}activity/2020TaxiGetNew/`;
const linkUrl = window.location.href;

export default {
  // list:['weixin', 'pengyou', 'dingding', 'weibo', 'qq', 'qzone'],
  list: ['weixin', 'pengyou', 'dingding'],
  hideMore: false, // 是否隐藏更多和复制链接
  title: '打车用高德，优惠折上折',
  wbTopic: '', // 微博话题在此配置 例:#微博活动#...
  message: '领取高德打车立减券，乘车享优惠',
  imgUrl: `${staticUrl}static/img/share_normal.png`,
  wbImgUrl: `${staticUrl}static/img/share_normal.png`,
  url: linkUrl,
};
